import { useNavigate } from "react-router-dom";
import { useState, useContext } from "react";
import { SUPER_ADMIN_CLIENTS_ROUTE} from "../../utils/Constants"
import { AuthContext } from "../../context/AuthContext";

export const useSuperAdmin = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const { authenticate } = useContext(AuthContext);

    const handleAccess = async (event) => {
        event.preventDefault();
        if (username && password) {
        try {
            const userResponse = await authenticate(username, password);
                  
            if(userResponse === null || userResponse === undefined) return alert("Erro no login.")
                  
            if(userResponse.role === "SUPER_ADMIN") {
                navigate(SUPER_ADMIN_CLIENTS_ROUTE);
            }else {
                alert("Usuário não autorizado.")
            }
        } catch (error) {
                console.error("Erro no login:", error.response?.status, error.response?.data);
                alert(`Erro no login: ${error.response?.status}`);
            }
        }
    };
    return { username, setUsername, password, setPassword, handleAccess, showPassword, setShowPassword };
};
